import {
  ChangeEventHandler,
  DetailedHTMLProps,
  InputHTMLAttributes,
} from 'react';
import { classNames } from '../../utils';

interface InputProps
  extends Omit<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'className' | 'value' | 'onChange'
  > {}

interface Props {
  title?: string;
  input?: InputProps;
  value?: number;
  readOnly?: boolean;
  className?: string;
  min: number;
  max: number;
  step?: number;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

export default function Slider({
  title,
  input,
  value,
  min,
  max,
  step = 1,
  readOnly,
  className,
  onChange,
}: Props) {
  return (
    <div>
      {title ? (
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {title}
        </label>
      ) : (
        <></>
      )}

      <input
        {...input}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        type="range"
        className={classNames(
          'w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer',
          className,
        )}
      />
    </div>
  );
}
